/**
 * Manage image path requests using the
 * DatasourceManager's url templating system.
 **/ 
define(function (require,exports,module) {
    'use strict'
    var Datasource=require('datasource-manager/lib/Datasource');
    var extend = require('datasource-manager/lib/extend');
    var getEnv = require('datasource-manager/env');
    
    var STRING='string';
    var PROD = "env_prod";
    
    function getTemplateFromPaths (paths, id) {
        return (typeof paths[id] === STRING) ? paths[id] : (paths[id][getEnv.env_prop] || paths[id][PROD])
    }

    function cacheHelper(_cache){
        var env = getEnv.env;
        if(_cache){
            return _cache[env] || (_cache[env]={})
        }
        return {};
    }

    function ResourcePathManager () {
        var cache = this.dscache = {};
        this.paths = {};
        this.collection = {};
        cache[getEnv.env]={};
    }

    ResourcePathManager.prototype = {
        /**
         * Get a path from the set of paths with key/value replacement
         * @param  {string} id          Name of the path to get
         * @param  {object} [params]    Key/value pair for replaceing placeholders
         * @return {string}             Evaluated path.
         */
        get: function (id,params) {
            var dscache = cacheHelper(this.dscache),
                path;
            if (this.paths[id]) {
                path = dscache[id];
                if(!path){
                    this.collection[id] = {
                        urlTemplate : getTemplateFromPaths(this.paths,id)
                    };
                    path=dscache[id] = new Datasource(id,this.collection);
                }
                return path.getUrl(params||{});
            }
            return "";
        },
        /**
         * Add a path or set of paths
         * @param {mixed}   id      Id or set of id/path pairs.  Takes a string or object.
         * @param {string}  [_path] Path to set as id.  If id is a collection, _path is not needed.
         */
        set: function (id,_path) {
            var key,
                path = id,
                path_ds = {};

            if(typeof id === STRING && !!_path) {
                path = {};
                path[id] = _path;
            }
            for (key in id) {
                this.clearCacheForId(key);
            }
            extend(this.paths,path);
        },
        /**
         * Retrieve a raw path from the defined paths
         * @param  {string} id  Path to retrieve.
         * @return {mixed}      Path template or undefined (if not defined).
         */
        getTemplate: function(id) {
            return getTemplateFromPaths(this.paths,id);
        },
        /**
         * Clear a compiled datasource from the cache. Useful if
         * there is an env switch.
         * @param  {string} id  Id of cached item to clear.
         * @return {boolean}    True if delete was successful, false it it was not.
         */
        clearCacheForId: function(id) {
            return delete cacheHelper(this.dscache)[id];
        }
    };

    return ResourcePathManager;
});
